<nav class="navbar navbar-expand-lg navbar-custom" style="background-color: #075b98; width: auto;">
  <a class="col-md-6" style="color: white; display: block; width: auto;">
    <img class="navbar-brand-logo navbar-brand-logo-normal"
      src="https://vkyc.federalbank.co.in/VKYC/Assets/images/logo.png" style="width: 149px;" 
      title="" alt="">     
  </a> 
  <a class="col-md-6" style="color: white; display: block; width: 25%;">
 
  <img class="navbar-brand-logo navbar-brand-logo-normal float-right"
  src="https://accountopen.federalbank.co.in/CustomerPortal/images/FedeLogo.svg"
   style="width: 149px;"
  title="" alt="">
  </a>
</nav>
<!-- <div>
<h1 class="h1 text_algn text-center" style="color:#0064A5;">Branch Change Portal</h1>
<p class="lead text_algn text-center">Change Your Home Branch Here.</p>
</div> -->
<router-outlet (activate)="changeOfRoutes()"></router-outlet>
<!-- <footer class="footer">
  <div class="container-footer">
    <span class="text-muted">&copy; Copy rights reserved</span>
  </div>
</footer> -->